import { lazy } from 'react';

export const WithdrawalReviewsForm = lazy(
  () => import('./WithdrawalReviewsForm'),
);
